module.exports = "assets/fc7fc47823d2fd76265a5705447f5bd9.gif";